
// 判断是否在金融app内
export const inJrApp = () => /jdjr-app/ig.test(navigator.userAgent);

export const getVersion = (reg, agent) => {
  reg = reg || /clientversion=(\d+\.\d+\.\d+)/i;
  agent = agent || navigator.userAgent;
  //var num = num || 1;
  ///clientversion=(\d+\.\d+\.\d+)/i.exec(window.navigator.userAgent)[1]
  var version = reg.exec(agent);
  if (version.length > 1) {
      return reg.exec(agent)[1] + '';
  }
  return '0.0.0';
};
// 获取版本号
export const getVersionNum = () => {
  let _versionnum = getVersion();
  _versionnum = _versionnum.replace(/\./g, '');
  if (_versionnum.length < 4 || _versionnum.startsWith('1')) {
      _versionnum = _versionnum + '0';
  }
  _versionnum = Number.parseInt(_versionnum);
  return _versionnum;
};

// 是否开启沉浸式导航
export const isNewTop = (
  version,
  headerData,
  no = 1,
  moreItem = true,
  isIndex = false,
  titleColor = 1
) => {
  if (inJrApp() && getVersionNum() > version) {
    openTransTitleBar(headerData, no, moreItem, isIndex, titleColor)
    return true
  } else {
    return false
  }
}

// 开启沉浸式导航
export const openTransTitleBar = (no, moreItem, isIndex, titleColor) => {
  window.JrBridge.setTopBar({
    version: 100,
    moreItem: moreItem,
    transparentConfig: {
      enable: true,
      title: document.title,
      normalConfig: {
        // 透明导航栏时的导航配置
        naviIcon: 1,
        showTitle: 0,
        bgColor: '',
      },
      scrollConfig: {
        // 页面滚动时的导航配置
        naviIcon: 2,
        showTitle: 1,
        bgColor: '#FFFFFF',
      }
    },
    rightItemList: [
      {
        "itemVersion": 0, //固定字段 传0
        "showItem": "", //显示在导航栏的按钮图片
        "jumpType": 2, //按钮功能枚举 -(0-无反应 1-跳转页面 2-分享数据 3-说明弹窗 4-调整h5字体大小)
        "jumpData": {
          "imageUrl": "https://storage.360buyimg.com/sharedata/logo300.png",//分享缩略图 必须为https的地址 小于32k,必传
          "linkSubtitle": '京东金融综合互联网理财服务，基金理财，金融服务，敬请享受！',//分享副标题 必传
          "linkTitle": '京东金融',// 分享主标题必传
          "channels": [//分享渠道 ：0-微信朋友圈，1-微信好友，2-新浪微博（已禁止），3-短信，4-QQ好友，5-QQ空间  6.1.20版本后不支持定制渠道
            "0",
            "1"
          ],
          "channelList": [{//建议使用的分享配置字段 5.1.0版本开始使用  支持分享链接(5.1.0) 、分享小程序（5.1.0）、分享纯文本（5.3.10）、分享口令弹窗（5.3.10）的分享字段
            "shareType": 0,//0:url(分享渠道均支持) 1:小程序(仅支持分享到微信好友) 2:纯文本(支持分享到微信好友，微信朋友圈) 3:口令弹窗(仅支持分享到微信好友) 必传
            "id": '1',//分享渠道  string类型 ：0-微信朋友圈，1-微信好友，2-新浪微博（已禁止），3-短信，4-QQ好友，5-QQ空间 必传
            /*链接分享数据*/
            "link": location.href, //分享出去的链接
          },
          {
            "shareType": 0,//0:url(分享渠道均支持) 1:小程序(仅支持分享到微信好友) 2:纯文本(支持分享到微信好友，微信朋友圈) 3:口令弹窗(仅支持分享到微信好友) 必传
            "id": 1,//分享渠道 ：0-微信朋友圈，1-微信好友，2-新浪微博（已禁止），3-短信，4-QQ好友，5-QQ空间 必传
            /*链接分享数据*/
            "link": location.href, //分享出去的链接
          }]
        }
      }
    ],
  })
}

// 设置分享导航内容
export const setShareText = (linkTitle, linkSubtitle, img, title) => {
  window.JrBridge.setTopBar({
    version: 100,
    moreItem: true,
    rightItemList: [
      {
        itemVersion: 0, // 固定字段 传0
        showItem: '', // 显示在导航栏的按钮图片
        jumpType: 2, // 按钮功能枚举 -(0-无反应 1-跳转页面 2-分享数据 3-说明弹窗 4-调整h5字体大小)
        jumpData: {
          imageUrl: 'https://storage.360buyimg.com/sharedata/logo300.png', // 分享缩略图 必须为https的地址 小于32k,必传
          linkSubtitle: linkSubtitle || '京东金融综合互联网理财服务，基金理财，金融服务，敬请享受！', // 分享副标题 必传
          linkTitle, // 分享主标题必传
          channels: [
            // 分享渠道 ：0-微信朋友圈，1-微信好友，2-新浪微博（已禁止），3-短信，4-QQ好友，5-QQ空间  6.1.20版本后不支持定制渠道
            '0',
            '1'
          ],
          channelList: [
            {
              // 建议使用的分享配置字段 5.1.0版本开始使用  支持分享链接(5.1.0) 、分享小程序（5.1.0）、分享纯文本（5.3.10）、分享口令弹窗（5.3.10）的分享字段
              shareType: 0, // 0:url(分享渠道均支持) 1:小程序(仅支持分享到微信好友) 2:纯文本(支持分享到微信好友，微信朋友圈) 3:口令弹窗(仅支持分享到微信好友) 必传
              id: '1', // 分享渠道  string类型 ：0-微信朋友圈，1-微信好友，2-新浪微博（已禁止），3-短信，4-QQ好友，5-QQ空间 必传
              /* 链接分享数据 */
              link: location.href // 分享出去的链接
            },
            {
              shareType: 0, // 0:url(分享渠道均支持) 1:小程序(仅支持分享到微信好友) 2:纯文本(支持分享到微信好友，微信朋友圈) 3:口令弹窗(仅支持分享到微信好友) 必传
              id: 1, // 分享渠道 ：0-微信朋友圈，1-微信好友，2-新浪微博（已禁止），3-短信，4-QQ好友，5-QQ空间 必传
              /* 链接分享数据 */
              link: location.href // 分享出去的链接
            }
          ]
        }
      }
    ],
    title
  })
}

// 加载js
export const loadScript = (url) => new Promise((resolve, reject) => {
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.onload = () => {
    resolve();
  };
  script.onerror = () => {
    reject(`加载${url}失败`);
  }
  script.src = url;
  document.head.appendChild(script);
})

// 判断是否加载bridge
export const checkJrBridge = () => new Promise(async (resolve) => {
  if (window.JrBridge && JrBridge.callNative) {
    resolve();
  } else {
    await loadScript('https://m.jr.jd.com/common/jssdk/jrbridge/2.0.9/jrbridge.js');
    resolve();
  }
})

export const getUrlParam = (name) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

export const getCustomUrlParam = (name) => {
  if (inJrApp() && getUrlParam('jrparam')) {
    try {
      const params = JSON.parse(decodeURIComponent(getUrlParam('jrparam')));
      return params[name];
    } catch (error) {
      return null;
    }
  } else {
    return getUrlParam(name);
  }
}


export const compareVersion = (v1, v2) => {
  v1 = v1.split('.')
  v2 = v2.split('.')
  const len = Math.max(v1.length, v2.length)

  while (v1.length < len) {
    v1.push('0')
  }
  while (v2.length < len) {
    v2.push('0')
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i])
    const num2 = parseInt(v2[i])

    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }

  return 0
}
// ios
export const isIos = () => {
  let isIos = /(iPhone|iPad|iPod)/i.test(navigator.userAgent);
  return isIos;
};

// Android
export const isAndroid = () => {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  return isAndroid;
};
//节流(立即执行)
export const throttle = (fn, wait) => {
  var flag = true;
  return function () {
    var context = this
    var args = arguments
    if (flag) {
      fn.apply(context, args);
      flag = false;
      setTimeout(() => {
        flag = true
      }, wait)
    }
  }
}
// 返回页面
export const again = cb => {
  JrBridge.callNative(
    {
      type: '65',
      url: location.href.split('?')[0]
    },
    data => {
      cb && cb();
    }
  );
};